// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icons-module--icon---gk9k"};